import _objectSpread from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module clipboard/dragdropblocktoolbar
 */
import { Plugin } from '@ckeditor/ckeditor5-core';
import { env, global, DomEmitterMixin } from '@ckeditor/ckeditor5-utils';
import ClipboardObserver from './clipboardobserver.js';
/**
 * Integration of a block Drag and Drop support with the block toolbar.
 *
 * @internal
 */
var DragDropBlockToolbar = /*#__PURE__*/function (_Plugin) {
  _inherits(DragDropBlockToolbar, _Plugin);
  var _super = _createSuper(DragDropBlockToolbar);
  function DragDropBlockToolbar() {
    var _this;
    _classCallCheck(this, DragDropBlockToolbar);
    _this = _super.apply(this, arguments);
    /**
     * Whether current dragging is started by block toolbar button dragging.
     */
    _this._isBlockDragging = false;
    /**
     * DOM Emitter.
     */
    _this._domEmitter = new (DomEmitterMixin())();
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(DragDropBlockToolbar, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this2 = this;
      var editor = this.editor;
      this.listenTo(editor, 'change:isReadOnly', function (evt, name, isReadOnly) {
        if (isReadOnly) {
          _this2.forceDisabled('readOnlyMode');
          _this2._isBlockDragging = false;
        } else {
          _this2.clearForceDisabled('readOnlyMode');
        }
      });
      if (env.isAndroid) {
        this.forceDisabled('noAndroidSupport');
      }
      if (editor.plugins.has('BlockToolbar')) {
        var blockToolbar = editor.plugins.get('BlockToolbar');
        var element = blockToolbar.buttonView.element;
        this._domEmitter.listenTo(element, 'dragstart', function (evt, data) {
          return _this2._handleBlockDragStart(data);
        });
        this._domEmitter.listenTo(global.document, 'dragover', function (evt, data) {
          return _this2._handleBlockDragging(data);
        });
        this._domEmitter.listenTo(global.document, 'drop', function (evt, data) {
          return _this2._handleBlockDragging(data);
        });
        this._domEmitter.listenTo(global.document, 'dragend', function () {
          return _this2._handleBlockDragEnd();
        }, {
          useCapture: true
        });
        if (this.isEnabled) {
          element.setAttribute('draggable', 'true');
        }
        this.on('change:isEnabled', function (evt, name, isEnabled) {
          element.setAttribute('draggable', isEnabled ? 'true' : 'false');
        });
      }
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this._domEmitter.stopListening();
      return _get(_getPrototypeOf(DragDropBlockToolbar.prototype), "destroy", this).call(this);
    }
    /**
     * The `dragstart` event handler.
     */
  }, {
    key: "_handleBlockDragStart",
    value: function _handleBlockDragStart(domEvent) {
      if (!this.isEnabled) {
        return;
      }
      var model = this.editor.model;
      var selection = model.document.selection;
      var view = this.editor.editing.view;
      var blocks = Array.from(selection.getSelectedBlocks());
      var draggedRange = model.createRange(model.createPositionBefore(blocks[0]), model.createPositionAfter(blocks[blocks.length - 1]));
      model.change(function (writer) {
        return writer.setSelection(draggedRange);
      });
      this._isBlockDragging = true;
      view.focus();
      view.getObserver(ClipboardObserver).onDomEvent(domEvent);
    }
    /**
     * The `dragover` and `drop` event handler.
     */
  }, {
    key: "_handleBlockDragging",
    value: function _handleBlockDragging(domEvent) {
      if (!this.isEnabled || !this._isBlockDragging) {
        return;
      }
      var clientX = domEvent.clientX + (this.editor.locale.contentLanguageDirection == 'ltr' ? 100 : -100);
      var clientY = domEvent.clientY;
      var target = document.elementFromPoint(clientX, clientY);
      var view = this.editor.editing.view;
      if (!target || !target.closest('.ck-editor__editable')) {
        return;
      }
      view.getObserver(ClipboardObserver).onDomEvent(_objectSpread(_objectSpread({}, domEvent), {}, {
        type: domEvent.type,
        dataTransfer: domEvent.dataTransfer,
        target: target,
        clientX: clientX,
        clientY: clientY,
        preventDefault: function preventDefault() {
          return domEvent.preventDefault();
        },
        stopPropagation: function stopPropagation() {
          return domEvent.stopPropagation();
        }
      }));
    }
    /**
     * The `dragend` event handler.
     */
  }, {
    key: "_handleBlockDragEnd",
    value: function _handleBlockDragEnd() {
      this._isBlockDragging = false;
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return 'DragDropBlockToolbar';
    }
  }]);
  return DragDropBlockToolbar;
}(Plugin);
export { DragDropBlockToolbar as default };